/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Ignore_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Ignore Event" |
*
* @param {Style_Guide_Ignore_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_ignore_aria_label = /** @type {((inputs?: Style_Guide_Ignore_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Ignore_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ignorer l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis ignorieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ignora evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Игнорировать событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ignorar evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("忽略事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを無視")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना को अनदेखा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ignorar evento")
	return /** @type {LocalizedString} */ ("Ignore Event")
});